<template>
  <Dialog :expanderClass="'d-inline'" ref="player">
    <template #expander="{ openModal }">
      <ButtonCustomized label="Add Player" @click="openModal" v-if="showBtn" /> 
      <a @click="openModal" v-if="!showBtn" > Add Player </a>
    </template>
    <template #dialog.title>
      Add Player
    </template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <h3>{{campaignTitle}}</h3>


      <!-- TODO (cleaner code): think about removing redundancy between "DeleteItemConfirmationForm" & other forms (e.g. CreateSlideForm) [DSP-N26Dui5A] -->
      <div>
        <SimpleEntityListingPage :entityItemsNamePlural="''" entityItemName="Player"
          areaAccessName="Players"
          :ItemsLister="PlayersLister" :selectMode=true  />
        <div class="form-buttons">
          <ButtonCustomized label="Add" @click="onSave" />
        </div>
      </div>

    </template>
  </Dialog>
</template>
    
<script lang="ts" setup>
import Dialog from '../../../components/Dialog/Dialog.vue';
import ButtonCustomized from "../../../components/form-fields/ButtonCustomized.vue";
import SimpleEntityListingPage from '@/components/ListingPages/SimpleEntityListingPage/SimpleEntityListingPage.vue';
import PlayersLister from '../../PlayersListView/PlayersLister/PlayersLister.vue';
import useListSelection from '@/components/ListingPages/ItemsLister/ItemsList/composables/listSelection';
import { ref } from 'vue';
const player = ref()
const emit = defineEmits(['cancel', 'save', 'exit', 'fail'])
defineProps({
  'campaignTitle': {
    type: String,
    default: ""
  },
  'showBtn':{
    type: Boolean,
    default: true
  }

})
const {
  selectedItemsIds,
  selectedItems,
  clearItemsSelection
} = useListSelection({
  clearSelectionTriggerElement: document.body
});

function onExit() {
  emit('exit')
}
async function onSave() {
  emit('save', selectedItems);
  clearItemsSelection () ;
  player.value.closeModal()
}

</script>
    
<style lang="scss" scoped>
.button {
  cursor: pointer;
}

.delete-item-form {
  display: flex;
  flex-direction: column;
  max-width: 30rem;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>